/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface IfrsQuestions {
  id: string;
  text: string;
  exhibits?: {
    id: string;
    title: string;
    type: "pdf" | "requirements" | "wordProcessor" | "spreadsheet" | "excel";
    filePath: string;
  }[];
  requirements: string;
  responseOptions: {
    wordProcessor: boolean;
    spreadsheet: boolean;
    spreadsheetFilePath?: string;
  };
}

export interface IFRSDTO {
  id: string;
  title: string;
  status: string;
  duration: number;
  lectureId: string;
  chapterId: string;
  createdAt: string;
  updatedAt: string;
  answer?: string;
  OpenLectureId?: string;
  ifrsQuestions?: IfrsQuestions[];
  videoId:string | null
  modelAnswerUrl?: string | null;
}

type GetIFRSResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: IFRSDTO;
};

export const GetIFRSById = async (quizId: string): Promise<GetIFRSResponse> => {
  try {
    const response = await axios.get(`/ifrs/${quizId}`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
